import { useContext, useMemo, useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { Permissions, useOrganisationsQuery } from '../types/graphqlTypes';
import { usePermissionDenied } from '../contexts/PermissionDeniedContext';

interface ProtectedLayoutProps {
  permissions: Permissions[];
}
export const ProtectedLayout: React.FC2<ProtectedLayoutProps> = ({ permissions, children }) => {
  const { organisationId = '' } = useParams();
  const user = useContext(UserContext);
  const { showPermissionDenied } = usePermissionDenied();

  const own = useMemo(() => user.organisations.find((o) => o.id === organisationId), [organisationId, user.organisations]);
  // Not one of the user's own: it may still be open to them through the partner scope, which the organisations
  // query grants and reports in myPermissions (the same query the organisation select asks, so one request).
  const { data, loading } = useOrganisationsQuery({ variables: { includeIds: [organisationId] }, skip: !organisationId || !!own || !!user.isSuperAdmin });
  const myPermissions = useMemo(() => own?.myPermissions ?? data?.organisations.find((o) => o.id === organisationId)?.myPermissions ?? [], [data?.organisations, organisationId, own]);
  const resolving = !own && !user.isSuperAdmin && loading;

  const hasPermission = !!user.isSuperAdmin || myPermissions.includes(Permissions.All) || permissions.some((p) => myPermissions.includes(p));

  useEffect(() => {
    if (!resolving && !hasPermission) {
      showPermissionDenied();
    }
  }, [hasPermission, resolving, showPermissionDenied]);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- FC2 requires ReactElement return, not ReactNode
  if (children) return <>{children}</>;
  return <Outlet />;
};
